import { EntityType } from '@frontend/common';
import { GroupSelectV2 } from '@frontend/group/select';
import { updateField } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useEquipmentGroupConstraintDataInput from './equipment-group-constraint-data-input.controller';

const ID = 'equipment-group-constraint-data-input';
export interface EquipmentGroupConstraintDataInputProps {
    dispatch: ThunkDispatch<any, any, Action>;
    formId: string;
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
}

const EquipmentGroupConstraintDataInput = (props: EquipmentGroupConstraintDataInputProps) => {
    const viewProps = useEquipmentGroupConstraintDataInput(props);

    return (
        <div
            id={ID}
            className='flex w-full flex-row'>
            <GroupSelectV2
                type={EntityType.EQUIPMENT_GROUP}
                required
                value={viewProps.formValues?.equipment_group_id ?? undefined}
                onChange={(v) => {
                    props.dispatch(updateField({ formId: props.formId, key: 'data', value: v ? { equipment_group_id: v } : undefined }));
                }}
            />
        </div>
    );
};

export default EquipmentGroupConstraintDataInput;
